import React, {lazy, Suspense} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {ContentRoute, LayoutSplashScreen} from "../../../_metronic/layout";
import SuppliersPage from "./SuppliersPage";
import {DashboardPage} from "./DashboardPage";
import BuyerAdminPage from "./BuyerAdminPage";


const GoogleMaterialPage = lazy(() =>
    import("../../modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
    import("../../modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
    import("../../modules/ECommerce/pages/eCommercePage")
);

export default function AdminBasePage() {
    // useEffect(() => {
    //   console.log('Base page');
    // }, []) // [] - is required if you need only one call
    // https://reactjs.org/docs/hooks-reference.html#useeffect

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    /* Redirect from root URL to /dashboard. */
                    <Redirect exact from="/" to="/supplierAdmin"/>
                }
                {/* <ContentRoute path="/dashboard" component={DashboardPage}/> */}
                {/* <ContentRoute path="/buyerAdmin" component={BuyerAdminPage}/> */}
                <ContentRoute path="/supplierAdmin" component={SuppliersPage}/>
                {/* <Route path="/google-material" component={GoogleMaterialPage}/>
                <Route path="/react-bootstrap" component={ReactBootstrapPage}/>
                <Route path="/e-commerce" component={ECommercePage}/> */}
                <Redirect to="error/error-v1"/>
            </Switch>
        </Suspense>
    );
}
